import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HistoryAnalysisRoutingModule } from './history-analysis-routing.module';
import { HistoryMapComponent } from './history-map/history-map.component';
import { SharedModule } from '../shared/shared.module';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeatmatrixComponent } from '../instant-analysis/heatmatrix/heatmatrix.component';
import { LegendComponent } from '../instant-analysis/legend/legend.component';
import { InstantAnalysisModule } from '../instant-analysis/instant-analysis.module';
import { RainChartComponent } from './rain-chart/rain-chart.component';
import { DiscreteChartComponent } from './discrete-chart/discrete-chart.component';
import { HistoryHeatmatrixComponent } from './history-heatmatrix/history-heatmatrix.component';
import { EventChartComponent } from './event-chart/event-chart.component';
import { SearchFieldComponent } from './search-field/search-field.component';

@NgModule({
  declarations: [
    HistoryMapComponent,
    SidebarComponent,
    RainChartComponent,
    DiscreteChartComponent,
    HistoryHeatmatrixComponent,
    EventChartComponent,
    // SearchFieldComponent,
  ],
  imports: [
    CommonModule,
    HistoryAnalysisRoutingModule,
    SharedModule,
    InstantAnalysisModule
  ]
})
export class HistoryAnalysisModule { }
